import ko from 'knockout';
import $ from 'jquery';
import flatpickr from 'flatpickr';
import Choices from 'choices.js';
import moment from 'moment';
import Inputmask from 'inputmask';
import numeral from 'numeral';

ko.bindingHandlers.selectPicker = {
    init: function (element: any, valueAccessor: any, allBindingsAccessor: any) {
        let options = allBindingsAccessor().selectPickerOptions;
        let initOptions = allBindingsAccessor().initPickerOptions;
        let choices = new Choices(element, initOptions);

        choices.setChoices(options.dataset(), options.valueField, options.labelField, true)

        ko.utils.registerEventHandler(element, 'addItem', () => {
            let values = <any[]>choices.getValue();
            let val = values.map((v) => { return { label: v.label, value: v.value } });
            choices.hideDropdown();
            valueAccessor()(val);
        });

        ko.utils.registerEventHandler(element, 'removeItem', () => {
            let values = <any[]>choices.getValue();
            let val = values.map((v) => { return { label: v.label, value: v.value } });
            valueAccessor()(val);
        });

        ko.utils.domNodeDisposal.addDisposeCallback(element, () => {
            choices.destroy();
        });
    }
}

//https://stackoverflow.com/questions/7395946/knockout-js-time-input-format-and-value-restriction
ko.bindingHandlers.numericValue = {
    init: function (element: any, valueAccessor: any, context: any) {
        var interceptor = ko.computed({
            read: function () {
                return ko.unwrap(valueAccessor());
            },
            write: function (value: any) {
                if (!isNaN(value)) {
                    valueAccessor()(parseInt(value));
                }
            },
            disposeWhenNodeIsRemoved: element
        });

        ko.applyBindingsToNode(element, { value: interceptor }, context);
    }
};

ko.bindingHandlers.datetimepicker = {
    init: function (element: any, valueAccessor: any, allBindingsAccessor: any) {
        var options = allBindingsAccessor().datetimepickerOptions;
        let picker = flatpickr(element, options);
        let $el = $(element);
        $el.data('dtp', picker);

        ko.utils.registerEventHandler(element, "change", function () {
            let momentValue = moment(element.value, 'DD-MM-YYYY HH:mm:ss');
            valueAccessor()(momentValue);
        });

        ko.utils.domNodeDisposal.addDisposeCallback(element, function () {
            (<any>element).flatpickr("destroy");
        });
    },
    update: function (element: any, valueAccessor: any) {
        let picker = $(element).data('dtp');
        let value = ko.unwrap(valueAccessor());
        picker.setDate(value.format('DD-MM-YYYY HH:mm:ss'));
    }
};

ko.bindingHandlers.decimalInputMask = {
    init: function (element, valueAccessor) {
        $(element).on('focusout change', function () {
            if (element.inputmask.isComplete()) {
                let number = numeral(element.value).value();
                valueAccessor()(number);
            } else {
                valueAccessor()(null);
            }
        });

        Inputmask('decimal', {
            rightAlign: false,
            autoGroup: true,
            digits: 2,
            radixPoint: ',',
            groupSeparator: '.'
        }).mask(element);
    },
    update: function (element, valueAccessor) {
        let value = ko.utils.unwrapObservable(valueAccessor());
        let text = numeral(value).format('0,0.00');
        element.value = text;
    }
}